const LOCAL_STORAGE_KEY = 'state_v1.0'

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    console.error('Error while loading state', err)
    return undefined
  }
}

export const saveState = (state) => {
  try {
    // Only save visited stations
    const savableState = {
      ui: {
        visitedTideStations: state.ui.visitedTideStations
      }
    }

    // Serialize state
    const serializedState = JSON.stringify(savableState)
    localStorage.setItem(LOCAL_STORAGE_KEY, serializedState)
  } catch(err) {
    console.log('Error while saving state', err)
  }
}



// WEBPACK FOOTER //
// ./src/localStorage.js